import {
    Button,
    Layout,
} from "antd";
import React, { useContext, useEffect } from "react";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";

const TestClient = () => {
    const { theme, setTheme } = useContext(ThemeContext)
    const { Content, Footer } = Layout;
    
    useEffect(() => {
        if (theme !== "primary") setTheme("primary")
    }, [theme])

    const DevURLSettings = () => (
        <div className="container mx-auto followingl-list flex md:flex-row flex-col gap-6 md:gap-10 w-full justify-center">
            <Button type="primary" size="large" href="http://localhost:3000/?Nr6OfW97D35kU10P6l5ackxIEd2yMPnye6a5eN3+szM=" className="min-w-[160px] leading-normal ">Trivalley</Button>
            <Button type="primary" size="large" href="http://localhost:3000/?rdraCzNj3IM4+e1jGAxR12D2mBDdZVdseFRzNu7Z6Pk=" className="min-w-[160px] leading-normal">Test Client 1</Button>
            <Button type="primary" size="large" href="http://localhost:3000/?94t+ApDa6h8dqbfAkP1iLUrFZvVIQqIHTn387KqyPk4=" className="min-w-[160px] leading-normal">Test Client 2</Button>
        </div>
    )
    const QAURLSettings = () => (
        <div className="container mx-auto followingl-list flex md:flex-row flex-col gap-6 md:gap-10 w-full justify-center">
            <Button type="primary" size="large" href="https://testrequest.provider1st.com/?KoVn0OsC9lySaj9QTP63hfHWXSeAV8I9gDFajrTyMsU=" className="min-w-[160px] leading-normal ">Trivalley</Button>
            <Button type="primary" size="large" href="https://testrequest.provider1st.com/?y3Xigud/vSajQlpx8fsvisUNOwhGlJ8fAV6j0oPeJNg=" className="min-w-[160px] leading-normal">Test Client 1</Button>
            <Button type="primary" size="large" href="https://testrequest.provider1st.com/?U6IHu5pFkvrBg7Lh1b8N2iLerHofwJkfS6CTFIOodqQ=" className="min-w-[160px] leading-normal">Test Client 2</Button>
        </div>
    )
    const QAURLSettings2 = () => (
        <div className="container mx-auto followingl-list flex md:flex-row flex-col gap-6 md:gap-10 w-full justify-center">
            <Button type="primary" size="large" href="http://192.168.90.81:81/?KoVn0OsC9lySaj9QTP63hfHWXSeAV8I9gDFajrTyMsU=" className="min-w-[160px] leading-normal ">Trivalley</Button>
            <Button type="primary" size="large" href="http://192.168.90.81:81/?y3Xigud/vSajQlpx8fsvisUNOwhGlJ8fAV6j0oPeJNg=" className="min-w-[160px] leading-normal">Test Client 1</Button>
            <Button type="primary" size="large" href="http://192.168.90.81:81/?U6IHu5pFkvrBg7Lh1b8N2iLerHofwJkfS6CTFIOodqQ=" className="min-w-[160px] leading-normal">Test Client 2</Button>
        </div>
    )
    const UATURLSettings = () => (
        <div className="container mx-auto followingl-list flex md:flex-row flex-col gap-6 md:gap-10 w-full justify-center">
            <Button type="primary" size="large" href="https://uatrequest.provider1st.com/?0r6svSpvqtBLS+fAJD+ogYxiIK84glWs2FOpHT+TaRQ=" className="min-w-[160px] leading-normal ">Trivalley</Button>
            <Button type="primary" size="large" href="https://uatrequest.provider1st.com/?3GIl1o6I44lxEki9BhLaJ5ZF626TMeDSq3eaqO2HECs=" className="min-w-[160px] leading-normal">Test Client 1</Button>
            <Button type="primary" size="large" href="https://uatrequest.provider1st.com/?/TeXyonDneYDyIMMKS310Klpm6FfEignzGxeDQrejZ0=" className="min-w-[160px] leading-normal">Test Client 2</Button>
        </div>
    )
    if (window.location.href.includes("https://testrequest.provider1st.com/")) {
        return (
            <Layout className="bg-white">
                <CustomHeader />
                <Content className="p-8 mt-20">
                    <QAURLSettings></QAURLSettings>
                </Content>
                <Footer className="welcome-footer bg-white">
                    <img
                        className="m-auto"
                        src={window.location.origin + "/assets/images/Logo.svg"}
                    />
                </Footer>
            </Layout>
        );
    }
    else if (window.location.href.includes("https://uatrequest.provider1st.com/")) {
        return (
            <Layout className="bg-white">
                <CustomHeader />
                <Content className="p-8 mt-20">
                    <UATURLSettings></UATURLSettings>
                </Content>
                <Footer className="welcome-footer bg-white">
                    <img
                        className="m-auto"
                        src={window.location.origin + "/assets/images/Logo.svg"}
                    />
                </Footer>
            </Layout>
        );
    }
    else if (window.location.href.includes("http://192.168.90.81:81/")) {
        return (
            <Layout className="bg-white">
                <CustomHeader />
                <Content className="p-8 mt-20">
                    <QAURLSettings2></QAURLSettings2>
                </Content>
                <Footer className="welcome-footer bg-white">
                    <img
                        className="m-auto"
                        src={window.location.origin + "/assets/images/Logo.svg"}
                    />
                </Footer>
            </Layout>
        );
    }
    else if (window.location.href.includes("http://localhost:3000/")) {
        return (
            <Layout className="bg-white">
                <CustomHeader />
                <Content className="p-8 mt-20">
                    <DevURLSettings></DevURLSettings>
                </Content>
                <Footer className="welcome-footer bg-white">
                    <img
                        className="m-auto"
                        src={window.location.origin + "/assets/images/Logo.svg"}
                    />
                </Footer>
            </Layout>
        );
    }
};

export default TestClient;
